<template>
  <div v-if="showStatusBar" id="status-bar" class="tui wrapper-status-bar" :data-type="type" >
    <div class="ui container">
      <div class="wrap-status-bar">
        <div class="wrap-title">
          <t-icon class="icon-bar" :icon="['far', getIcon]" :spin="getIcon === 'spinner'" />
          <h2 class="title" v-html="titleStatusbar" />
        </div>
        <button class="ui button ui-icon" @click="close" >
          <t-icon class="icon-bar" :icon="['fas', 'times']" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TStatusBar',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getIcon () {
      if ( this.type === 'success' ) {
        return 'check'
      } else if ( this.type === 'error' ) {
        return 'exclamation-triangle'
      }

      return 'spinner'
    },

    ...mapState({
      showStatusBar: ({ statusBar }) => statusBar.showStatusBar,
      type: ({ statusBar }) => statusBar.type,
      titleStatusbar: ({ statusBar }) => statusBar.titleStatusbar
    })
  },

  methods: {
    ...mapActions('statusBar', ['toggleStatusBar']),

    close () {
      this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.wrapper-status-bar {
  position: relative;
  width: 100%;
  height: auto;
  visibility: visible;
  background-color: $gray-500;

  &.show {
    height: auto;
    visibility: visible;
  }

  &[data-type="success"] { background: $green-500; }
  &[data-type="error"] { background: $red-500; }
  &[data-type="warning"] { background: $gray-500; }
  &[data-type="info"] { background: $blue-500; }

  .wrap-status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;

    .wrap-title {
      display: flex;
      align-items: center;

      .title {
        font-size: 16px;
        line-height: 23px;
        font-weight: 400;
        color: $white-100;
        margin: 0 15px;
      }

      .icon-bar {
        color: $white-100;
      }
    }

    button.ui.button.ui-icon {
      background-color: transparent;
      color: $white-100;
      font-size: 18px;
      padding: 10px 0;
    }
  }
}
</style>
